import * as types from '../actions/actionTypes';

const initialState = {
  billingDetails: {},
  billingHistory: [],
};

export const billingReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.LOAD_BILLING_DETAILS: {
    return {
      ...state,
      billingDetails: action.billingDetails,
    };
  }
  case types.LOAD_BILLING_HISTORY: {
    return {
      ...state,
      billingHistory: action.billingHistory,
    };
  }
  default:
    return state;
  }
};
